import { lazy } from "react";

const MainSubscriptionPage = lazy(() => import("../Component/SubscriptionFeeBilling/MainSubscripttionPage"));

const subscriptionRoutes = [
  { path: "/subscription-billing", element: <MainSubscriptionPage />, protected: false },
];

export default subscriptionRoutes;
